var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9337 10.5096C20.9337 5.29523 16.7066 1.06812 11.4922 1.06812V10.5096H20.9337Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19159 1.60377C8.43738 2.09835 8.23569 2.69853 7.74111 2.94432C4.95914 4.32684 3.05078 7.19594 3.05078 10.5089C3.05078 15.171 6.83018 18.9504 11.4923 18.9504C14.8053 18.9504 17.6744 17.0421 19.0569 14.2601C19.3027 13.7655 19.9029 13.5639 20.3975 13.8096C20.892 14.0554 21.0937 14.6556 20.8479 15.1502C19.1406 18.5858 15.5935 20.9504 11.4923 20.9504C5.72562 20.9504 1.05078 16.2756 1.05078 10.5089C1.05078 6.40774 3.41538 2.86067 6.85105 1.15329C7.34562 0.907506 7.94581 1.10919 8.19159 1.60377Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralInfo);
export default __webpack_public_path__ + "static/media/general-info.de20404683f5b2c8b1290742a35cc087.svg";
export { ForwardRef as ReactComponent };